export const validateName = (name) => {
  return name ? name.replace(/[a-zA-Z0-9&._-]/, "") : "";
};
export const validateEmail = (email) => {
  return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
    email
  );
};

export const formatTimeShow = (time) => {
  let timeSubString = time
    .toString()
    .substring(0, time.toString().indexOf(":"));
  var ampm = "am";
  if (timeSubString >= 12) ampm = "pm";
  timeSubString = timeSubString % 12;
  if (timeSubString == 0) timeSubString = 12;
  return timeSubString + ampm;
};

export const getNumericValue = (text) =>
  text ? text.replace(/[^0-9]/g, "") : "";

export const passwordValidation = (value) => {
  const passwordInputValue = value.trim();
  const uppercaseRegExp = /(?=.*?[A-Z])/;
  const lowercaseRegExp = /(?=.*?[a-z])/;
  const digitsRegExp = /(?=.*?[0-9])/;
  const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
  const minLengthRegExp = /.{8,}/;
  const passwordLength = passwordInputValue.length;
  const uppercasePassword = uppercaseRegExp.test(passwordInputValue);
  const lowercasePassword = lowercaseRegExp.test(passwordInputValue);
  const digitsPassword = digitsRegExp.test(passwordInputValue);
  const specialCharPassword = specialCharRegExp.test(passwordInputValue);
  const minLengthPassword = minLengthRegExp.test(passwordInputValue);
  let errMsg = "";
  if (passwordLength === 0) {
    errMsg = "The Password cannot be empty";
  } else if (!uppercasePassword) {
    errMsg = "The Password should have at least one Uppercase";
  } else if (!lowercasePassword) {
    errMsg = "The Password should have at least one Lowercase";
  } else if (!digitsPassword) {
    errMsg = "The Password should have at least one digit";
  } else if (!specialCharPassword) {
    errMsg = "The Password should have at least one Special Characters";
  } else if (!minLengthPassword) {
    errMsg = "The Password should have minumum of 8 characters";
  }
  return errMsg;
};

export const months = [
  "Jan",
  "Feb",
  "March",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

export const getCookie = (name) => {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
};

export const setCookie = (key, value, expiry, domain, path) => {
  document.cookie =
    key +
    "=" +
    value +
    ";expires=" +
    expiry +
    ";domain=" +
    domain +
    ";path=" +
    path;
};

export const setCookieWithSecureFlag = (key, value, expiry, domain, path) => {
  document.cookie =
    key +
    "=" +
    value +
    ";expires=" +
    expiry +
    ";domain=" +
    domain +
    ";path=" +
    path +
    ";SameSite=None;Secure";
};

export const setLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {}
};

export const getLocalStorage = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {}
};

export const removeLocalStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {}
};

export const clearLocalStorage = () => {
  try {
    localStorage.clear();
  } catch (e) {}
};

export const removeCookie = (name) => {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};

export const clearCookies = () => {
  document.cookie.split(";").forEach(function (cookie) {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/");
  });
};
